'use client';
import Typography from '@/components/shared/typography/typography.component';
import classes from './styles.module.scss';

const RadioBoxSimple = ({
  text,
  value,
  selected,
  radioBoxClicked,
  variant,
}: {
  text: string;
  value: string;
  selected: boolean;
  radioBoxClicked: (text: string) => void;
  variant?: 'row' | 'row-reverse';
}) => {
  const rowReverse = variant === 'row-reverse';
  return (
    <div
      onClick={() => radioBoxClicked(value)}
      className={`${classes.container} ${selected ? classes.active : ''}`}
      style={{
        flexDirection: variant,
        justifyContent: rowReverse ? 'flex-end' : 'space-between',
        gap: rowReverse ? '8px' : '',
      }}
    >
      <Typography variant="body2Medium" className={classes.container__text}>
        {text}
      </Typography>
      <div className={`${classes.container__radioButton} ${selected ? classes.active : ''}`}>
        <div
          className={`${classes.container__radioButton__check} ${selected ? classes.active : ''}`}
        ></div>
      </div>
    </div>
  );
};

export default RadioBoxSimple;
